const Account = () => import(/* webpackChunkName: 'account' */ './home');
const Login = () => import(/* webpackChunkName: 'account' */ './login');
const Entering = () => import(/* webpackChunkName: 'account' */ './entering');
const Process = () => import(/* webpackChunkName: 'account' */ './process');
const FindPassword = () => import(/* webpackChunkName: 'account' */ './findPassword');
const Rqhome = () => import(/* webpackChunkName: 'account' */ './rqhome');

const routes = [
  { path: '/', component: Account },
  { path: '/account/login', component: Login },
  { path: '/account/entering', component: Entering },
  { path: '/account/process', component: Process },
  { path: '/account/findpassword', component: FindPassword },
  { path: '/account/rqhome', component: Rqhome },
];

export default routes;
